//import React from 'react';
//import RadioButtonDistributionCodeColumn from './RadioButtonDistributionCodeColumn.jsx';

//let confirmationCheck, getRadio;
//var RadioButtonDistributionCode = React.createClass({
//    render: function () {
//        let radioNodes;
//        if (this.props.data != undefined && this.props.data != "") {
//            getRadio = this.props.getRadio;
//            //confirmationCheck = this.props.data.codigo.id;
//            radioNodes = this.props.data.codigoDistribucion.map(function (row) {
//                let checked = (confirmationCheck == row.Id) ? true : false;
//                return (
//                    <RadioButtonDistributionCodeColumn Id={row.Id} checked={checked} getRadio={this.getRadio} CodigoDistribucion={row.CodigoDistribucion} key={"RadioButtonDistributionCodeColumn_" + row.Id} />
//                );
//            })
//        };
//        return (
//            <div className="row">
//                <div className="col-xs-12">
//                    {radioNodes}
//                </div>
//            </div>
//        );
//    }

//});

//export default RadioButtonDistributionCode



import React from 'react';
import RadioButtonDistributionCodeColumn from './RadioButtonDistributionCodeColumn.jsx';

const RadioButtonDistributionCode = (props) => {
    let radioNodes;

    if (props.data != undefined && props.data != "") {
        let confirmationCheck = props.data.idCodigoDistribucion;
        radioNodes = props.data.codigoDistribucion.map(function (row) {
            let checked = (row.seleccionada == true || row.Id == confirmationCheck) ? true : false;
            return (
                <RadioButtonDistributionCodeColumn data={props.data} Id={row.Id} checked={checked} getRadio={props.getRadio} CodigoDistribucion={row.CodigoDistribucion} key={"RadioButtonDistributionCodeColumn_" + row.Id} />
            );
        })
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                {radioNodes}                
            </div>
            <div>
                {props.data.ERROR_CARD["seleccionoCodigoDistribucion"] == false ? <label className="error">Debe seleccionar al menos un código de distribución.</label> : null }
            </div>
        </div>
    );

    //return (
    //    <tr className={props.className}>
    //        <td className="default-td">
    //            <a className={linkClass} /*onClick={props.toggleAccountViewFn}*/>{description}</a>
    //        </td>
    //        <td className={tdClass}>
    //            ${props.limit}
    //        </td>
    //        <td className={tdClass}>
    //            {props.suc}
    //        </td>
    //        <td className="default-td">
    //            <a className="btn-link">{cards}</a>
    //        </td>
    //    </tr>
    //);
}

export default RadioButtonDistributionCode;